var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuidelines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M672.251,235.033c-20.538-36.17-45.863-69.383-75.128-98.685 c-31.579-31.618-63.772-52.993-105.301-66.826c-28.117-9.366-57.446-14.725-86.907-15.721 c-54.784-1.852-99.973,11.193-144.979,44.105c-48.25,35.285-93.262,75.215-140.281,112.271c-4.908,3.868-9.835,7.708-14.788,11.51 C22.863,284.635-16.968,396.451,38.483,423.784h638.071c0,0,58.04-3.068,43.735-65.435 C710.277,314.695,693.932,273.216,672.251,235.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M672.251,235.033c-20.538-36.17-45.863-69.383-75.128-98.685 c-31.579-31.618-63.772-52.993-105.301-66.826c-28.117-9.366-57.446-14.725-86.907-15.721 c-54.784-1.852-99.973,11.193-144.979,44.105c-48.25,35.285-93.262,75.215-140.281,112.271c-4.908,3.868-9.835,7.708-14.788,11.51 C22.863,284.635-16.968,396.451,38.483,423.784h638.071c0,0,58.04-3.068,43.735-65.435 C710.277,314.695,693.932,273.216,672.251,235.033z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M45.8,354.077c2.18,0.952,7.513,0.832,7.518,0.832c0.055-0.001-1.146-3.491-1.247-3.703 c-1.17-2.448-4.87-6.49-7.882-6.083c-2.169,0.293-3.375,2.464-2.886,4.506C41.804,351.716,43.943,353.265,45.8,354.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M47.641,369.524c2.262,0.33,7.021-1.05,7.4-1.162c0.752,2.665,1.739,5.338,2.887,7.987 c0.654,1.516,1.361,3.022,2.088,4.523c-0.434-0.636-0.827-1.201-0.89-1.275c-1.776-2.052-6.412-4.973-9.208-3.785 c-2.015,0.855-2.605,3.267-1.593,5.108c1.033,1.88,3.507,2.81,5.512,3.102c2.035,0.297,6.116-0.799,7.193-1.103 c0.285,0.573,0.563,1.148,0.851,1.72c1.378,2.744,2.765,5.477,4.044,8.199c0.451,0.959,0.86,1.92,1.273,2.88 c-0.386-0.565-0.716-1.037-0.774-1.104c-1.775-2.051-6.411-4.973-9.208-3.785c-2.015,0.855-2.605,3.268-1.593,5.108 c1.034,1.88,3.507,2.809,5.512,3.101c1.942,0.283,5.718-0.694,6.998-1.049c0.393,0.996,0.788,1.993,1.124,2.976 c0.214,0.676,0.468,1.312,0.644,2.003c0.19,0.681,0.378,1.355,0.564,2.022c0.312,1.298,0.641,2.635,0.913,3.909 c0.196,0.885,0.366,1.731,0.54,2.584c-0.438-0.96-1.335-2.821-1.427-2.968c-1.443-2.297-5.583-5.886-8.528-5.136 c-2.121,0.541-3.07,2.835-2.348,4.808c0.736,2.014,3.04,3.308,4.978,3.9c2.134,0.652,6.858,0.056,7.447-0.022 c0.283,1.411,0.545,2.787,0.771,4.089c0.507,2.873,0.889,5.449,1.179,7.629h1.992c-0.347-2.255-0.801-4.942-1.402-7.959 c-0.281-1.434-0.611-2.962-0.964-4.527c0.355-0.141,2.37-0.956,4.155-1.954c1.555,1.684,5.54,3.655,6.056,3.906 c-0.542,1.334-1.083,2.625-1.612,3.836c-1.102,2.536-2.148,4.785-3.072,6.698h2.154c0.794-1.763,1.667-3.772,2.577-5.997 c0.556-1.352,1.124-2.808,1.693-4.307c0.572,0.119,5.248,1.069,7.427,0.577c1.976-0.447,4.37-1.565,5.256-3.519 c0.866-1.913,0.091-4.272-1.985-4.969c-2.879-0.968-7.276,2.303-8.887,4.487c-0.096,0.129-0.97,1.641-1.506,2.604 c0.229-0.614,0.458-1.208,0.686-1.843c0.46-1.253,0.882-2.517,1.34-3.875c0.199-0.664,0.399-1.334,0.602-2.011 c0.215-0.667,0.357-1.399,0.541-2.104c0.392-1.645,0.708-3.33,0.99-5.035c1.098,0.4,5.018,1.763,7.049,1.62 c2.022-0.142,4.557-0.884,5.727-2.682c1.146-1.759,0.737-4.209-1.208-5.213c-2.701-1.393-7.542,1.175-9.465,3.089 c-0.12,0.119-1.345,1.648-2.002,2.5c0.161-1.026,0.327-2.05,0.456-3.094c0.374-3.012,0.658-6.074,0.956-9.126 c0.09-0.935,0.192-1.866,0.29-2.798c0.389,0.146,5.013,1.868,7.288,1.708c2.021-0.142,4.557-0.885,5.728-2.682 c1.146-1.759,0.737-4.209-1.208-5.212c-2.7-1.393-7.541,1.174-9.464,3.088c-0.145,0.144-1.905,2.346-2.326,2.928 c0.217-2.053,0.452-4.096,0.766-6.101c0.428-2.767,1.003-5.458,1.751-8.024c0.181,0.069,4.999,1.887,7.329,1.724 c2.022-0.142,4.558-0.885,5.728-2.682c1.146-1.76,0.737-4.209-1.208-5.213c-2.701-1.393-7.541,1.175-9.465,3.089 c-0.15,0.15-2.043,2.52-2.356,2.974c0.045-0.152,0.075-0.315,0.121-0.467c0.834-2.729,1.985-5.268,3.179-7.593 c0.691-1.352,1.428-2.606,2.171-3.81c0.863,0.431,4.827,2.356,6.94,2.44c2.025,0.081,4.627-0.379,5.988-2.037 c1.333-1.623,1.195-4.103-0.628-5.314c-2.532-1.681-7.625,0.34-9.746,2.031c-0.115,0.092-1.185,1.157-1.952,1.943 c0.344-0.538,0.688-1.1,1.028-1.609c1.271-1.914,2.553-3.588,3.7-5.063c0.659-0.832,1.271-1.572,1.852-2.259 c1.067-0.018,5.366-0.149,7.246-1.032c1.834-0.862,3.932-2.468,4.375-4.567c0.434-2.055-0.831-4.193-3.007-4.427 c-3.021-0.326-6.611,3.814-7.715,6.293c-0.095,0.215-1.202,3.736-1.146,3.735c0,0,0.052,0,0.065-0.001 c-0.572,0.649-1.177,1.352-1.824,2.133c-1.182,1.452-2.504,3.103-3.821,4.997c-1.322,1.889-2.704,3.979-3.962,6.312 c-1.264,2.337-2.474,4.859-3.384,7.619c-0.011,0.031-0.017,0.065-0.028,0.096c0.016-0.89-0.023-3.38-0.048-3.57 c-0.349-2.691-2.603-7.685-5.592-8.238c-2.152-0.397-3.975,1.289-4.147,3.382c-0.175,2.138,1.375,4.277,2.887,5.628 c1.704,1.522,6.436,2.997,6.812,3.113c-0.843,2.636-1.494,5.41-1.999,8.254c-0.29,1.626-0.532,3.272-0.753,4.925 c-0.011-0.77-0.027-1.458-0.04-1.554c-0.349-2.691-2.604-7.684-5.592-8.237c-2.153-0.398-3.975,1.289-4.147,3.382 c-0.175,2.138,1.375,4.277,2.886,5.627c1.534,1.37,5.542,2.708,6.607,3.048c-0.078,0.635-0.163,1.269-0.239,1.905 c-0.365,3.049-0.715,6.094-1.15,9.069c-0.152,1.049-0.342,2.076-0.527,3.104c-0.011-0.684-0.026-1.259-0.037-1.347 c-0.349-2.691-2.604-7.685-5.591-8.237c-2.153-0.397-3.976,1.288-4.148,3.382c-0.175,2.137,1.376,4.277,2.887,5.627 c1.463,1.307,5.152,2.576,6.416,2.986c-0.222,1.047-0.442,2.097-0.704,3.102c-0.195,0.682-0.334,1.352-0.568,2.027 c-0.217,0.672-0.432,1.338-0.644,1.997c-0.457,1.255-0.92,2.552-1.396,3.765c-0.325,0.846-0.65,1.646-0.975,2.453 c0.164-1.042,0.443-3.089,0.447-3.262c0.041-1.802-0.598-4.732-1.872-6.792c0.008-0.266-0.007-0.531-0.049-0.795 c-0.333-2.073-2.281-3.614-4.397-3.05c-2.936,0.781-4.798,5.935-4.937,8.645c-0.008,0.16,0.096,1.904,0.18,3.004 c-0.148-0.639-0.284-1.26-0.444-1.916c-0.308-1.299-0.654-2.585-1.02-3.972c-0.2-0.663-0.403-1.332-0.608-2.009 c-0.188-0.675-0.474-1.363-0.71-2.053c-0.581-1.587-1.246-3.169-1.952-4.746c1.137-0.272,5.159-1.298,6.773-2.537 c1.608-1.233,3.313-3.252,3.298-5.396c-0.015-2.101-1.707-3.918-3.883-3.682c-3.021,0.328-5.642,5.14-6.191,7.797 c-0.034,0.166-0.213,2.117-0.291,3.19c-0.432-0.945-0.858-1.89-1.326-2.832c-1.35-2.719-2.8-5.429-4.236-8.139 c-0.44-0.83-0.869-1.662-1.302-2.493c0.406-0.093,5.212-1.208,7.022-2.596c1.607-1.233,3.313-3.252,3.298-5.397 c-0.015-2.1-1.707-3.918-3.883-3.681c-3.021,0.328-5.642,5.14-6.191,7.797c-0.041,0.2-0.295,3.007-0.324,3.724 c-0.951-1.831-1.882-3.665-2.727-5.51c-1.168-2.544-2.175-5.105-2.966-7.658c0.189-0.043,5.211-1.185,7.064-2.606 c1.608-1.234,3.313-3.252,3.298-5.397c-0.015-2.1-1.707-3.917-3.883-3.681c-3.021,0.328-5.642,5.14-6.19,7.797 c-0.043,0.209-0.314,3.229-0.324,3.78c-0.047-0.152-0.112-0.304-0.157-0.456c-0.81-2.737-1.251-5.489-1.537-8.087 c-0.169-1.509-0.247-2.96-0.291-4.374c0.957-0.117,5.325-0.698,7.134-1.793c1.734-1.05,3.65-2.868,3.871-5.002 c0.215-2.089-1.267-4.082-3.456-4.086c-3.039-0.006-6.173,4.49-7.009,7.07c-0.046,0.141-0.35,1.618-0.557,2.698 c-0.01-0.638-0.032-1.297-0.03-1.909c0.004-2.298,0.149-4.402,0.293-6.264c0.09-1.058,0.193-2.014,0.299-2.906 c0.879-0.605,4.393-3.085,5.474-4.858c1.055-1.73,1.917-4.227,1.13-6.223c-0.771-1.953-3.005-3.038-4.949-2.034 c-2.699,1.395-3.409,6.829-2.963,9.505c0.039,0.231,1.058,3.779,1.104,3.748c0,0,0.043-0.03,0.053-0.037 c-0.119,0.857-0.236,1.777-0.344,2.785c-0.185,1.863-0.377,3.969-0.431,6.275c-0.06,2.305-0.061,4.811,0.177,7.45 c0.235,2.645,0.617,5.417,1.38,8.222c0.009,0.032,0.022,0.064,0.031,0.095c-0.478-0.751-1.885-2.806-2.011-2.951 c-1.775-2.052-6.411-4.973-9.208-3.786c-2.014,0.856-2.605,3.268-1.593,5.109C43.163,368.303,45.636,369.232,47.641,369.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M99.744,355.25c0.047,0.029,0.97-3.545,1.003-3.777c0.374-2.687-0.483-8.099-3.219-9.421 c-1.97-0.952-4.174,0.193-4.892,2.167c-0.734,2.015,0.196,4.488,1.298,6.189C95.225,352.406,99.74,355.247,99.744,355.25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M667.312,354.077c2.18,0.952,7.513,0.832,7.518,0.832c0.055-0.001-1.146-3.491-1.247-3.703 c-1.17-2.448-4.871-6.49-7.881-6.083c-2.169,0.293-3.375,2.464-2.886,4.506C663.315,351.716,665.455,353.265,667.312,354.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M669.153,369.524c2.262,0.33,7.021-1.05,7.4-1.162c0.752,2.665,1.739,5.338,2.887,7.987 c0.654,1.516,1.361,3.022,2.088,4.523c-0.434-0.636-0.827-1.201-0.89-1.275c-1.776-2.052-6.412-4.973-9.208-3.785 c-2.016,0.855-2.605,3.267-1.594,5.108c1.033,1.88,3.507,2.81,5.512,3.102c2.035,0.297,6.116-0.799,7.193-1.103 c0.285,0.573,0.563,1.148,0.851,1.72c1.378,2.744,2.765,5.477,4.044,8.199c0.451,0.959,0.86,1.92,1.273,2.88 c-0.386-0.565-0.716-1.037-0.774-1.104c-1.775-2.051-6.411-4.973-9.208-3.785c-2.015,0.855-2.605,3.268-1.594,5.108 c1.034,1.88,3.507,2.809,5.512,3.101c1.942,0.283,5.718-0.694,6.999-1.049c0.393,0.996,0.788,1.993,1.124,2.976 c0.214,0.676,0.468,1.312,0.644,2.003c0.19,0.681,0.378,1.355,0.564,2.022c0.312,1.298,0.641,2.635,0.913,3.909 c0.196,0.885,0.366,1.731,0.54,2.584c-0.438-0.96-1.335-2.821-1.427-2.968c-1.443-2.297-5.583-5.886-8.528-5.136 c-2.121,0.541-3.07,2.835-2.348,4.808c0.736,2.014,3.04,3.308,4.978,3.9c2.134,0.652,6.858,0.056,7.447-0.022 c0.283,1.411,0.545,2.787,0.771,4.089c0.507,2.873,0.889,5.449,1.179,7.629h1.992c-0.347-2.255-0.801-4.942-1.401-7.959 c-0.281-1.434-0.611-2.962-0.965-4.527c0.355-0.141,2.37-0.956,4.155-1.954c1.555,1.684,5.54,3.655,6.056,3.906 c-0.542,1.334-1.083,2.625-1.612,3.836c-1.102,2.536-2.148,4.785-3.072,6.698h2.154c0.794-1.763,1.667-3.772,2.577-5.997 c0.556-1.352,1.125-2.808,1.693-4.307c0.572,0.119,5.248,1.069,7.427,0.577c1.976-0.447,4.37-1.565,5.256-3.519 c0.866-1.913,0.091-4.272-1.985-4.969c-2.879-0.968-7.276,2.303-8.887,4.487c-0.096,0.129-0.97,1.641-1.506,2.604 c0.229-0.614,0.458-1.208,0.686-1.843c0.46-1.253,0.882-2.517,1.34-3.875c0.199-0.664,0.399-1.334,0.602-2.011 c0.215-0.667,0.357-1.399,0.541-2.104c0.392-1.645,0.708-3.33,0.99-5.035c1.098,0.4,5.018,1.763,7.049,1.62 c2.022-0.142,4.557-0.884,5.727-2.682c1.146-1.759,0.737-4.209-1.208-5.213c-2.701-1.393-7.542,1.175-9.465,3.089 c-0.12,0.119-1.345,1.648-2.002,2.5c0.161-1.026,0.327-2.05,0.456-3.094c0.374-3.012,0.659-6.074,0.956-9.126 c0.091-0.935,0.192-1.866,0.29-2.798c0.39,0.146,5.013,1.868,7.288,1.708c2.021-0.142,4.557-0.885,5.728-2.682 c1.146-1.759,0.737-4.209-1.208-5.212c-2.7-1.393-7.541,1.174-9.464,3.088c-0.145,0.144-1.905,2.346-2.325,2.928 c0.217-2.053,0.452-4.096,0.766-6.101c0.428-2.767,1.003-5.458,1.751-8.024c0.181,0.069,4.999,1.887,7.329,1.724 c2.022-0.142,4.558-0.885,5.728-2.682c1.146-1.76,0.737-4.209-1.208-5.213c-2.701-1.393-7.541,1.175-9.465,3.089 c-0.15,0.15-2.043,2.52-2.356,2.974c0.045-0.152,0.075-0.315,0.121-0.467c0.834-2.729,1.985-5.268,3.179-7.593 c0.691-1.352,1.427-2.606,2.171-3.81c0.863,0.431,4.827,2.356,6.94,2.44c2.025,0.081,4.627-0.379,5.987-2.037 c1.333-1.623,1.195-4.103-0.628-5.314c-2.531-1.681-7.625,0.34-9.746,2.031c-0.115,0.092-1.185,1.157-1.952,1.943 c0.344-0.538,0.688-1.1,1.028-1.609c1.271-1.914,2.553-3.588,3.7-5.063c0.659-0.832,1.271-1.572,1.852-2.259 c1.067-0.018,5.366-0.149,7.246-1.032c1.834-0.862,3.932-2.468,4.376-4.567c0.434-2.055-0.831-4.193-3.006-4.427 c-3.021-0.326-6.611,3.814-7.715,6.293c-0.095,0.215-1.202,3.736-1.147,3.735c0,0,0.052,0,0.065-0.001 c-0.572,0.649-1.177,1.352-1.823,2.133c-1.182,1.452-2.504,3.103-3.821,4.997c-1.322,1.889-2.704,3.979-3.962,6.312 c-1.264,2.337-2.474,4.859-3.384,7.619c-0.011,0.031-0.017,0.065-0.028,0.096c0.016-0.89-0.023-3.38-0.048-3.57 c-0.349-2.691-2.603-7.685-5.592-8.238c-2.153-0.397-3.975,1.289-4.147,3.382c-0.175,2.138,1.375,4.277,2.887,5.628 c1.704,1.522,6.436,2.997,6.812,3.113c-0.843,2.636-1.494,5.41-1.999,8.254c-0.29,1.626-0.532,3.272-0.753,4.925 c-0.011-0.77-0.027-1.458-0.04-1.554c-0.349-2.691-2.604-7.684-5.592-8.237c-2.153-0.398-3.975,1.289-4.147,3.382 c-0.175,2.138,1.375,4.277,2.886,5.627c1.534,1.37,5.542,2.708,6.607,3.048c-0.078,0.635-0.164,1.269-0.239,1.905 c-0.365,3.049-0.715,6.094-1.15,9.069c-0.152,1.049-0.342,2.076-0.527,3.104c-0.011-0.684-0.026-1.259-0.037-1.347 c-0.349-2.691-2.604-7.685-5.591-8.237c-2.153-0.397-3.976,1.288-4.148,3.382c-0.175,2.137,1.375,4.277,2.887,5.627 c1.463,1.307,5.152,2.576,6.416,2.986c-0.221,1.047-0.442,2.097-0.704,3.102c-0.195,0.682-0.335,1.352-0.568,2.027 c-0.217,0.672-0.432,1.338-0.644,1.997c-0.457,1.255-0.92,2.552-1.396,3.765c-0.325,0.846-0.65,1.646-0.975,2.453 c0.164-1.042,0.443-3.089,0.447-3.262c0.041-1.802-0.598-4.732-1.872-6.792c0.008-0.266-0.007-0.531-0.049-0.795 c-0.333-2.073-2.281-3.614-4.397-3.05c-2.936,0.781-4.798,5.935-4.937,8.645c-0.008,0.16,0.096,1.904,0.18,3.004 c-0.148-0.639-0.284-1.26-0.444-1.916c-0.308-1.299-0.654-2.585-1.02-3.972c-0.2-0.663-0.403-1.332-0.608-2.009 c-0.189-0.675-0.474-1.363-0.71-2.053c-0.581-1.587-1.246-3.169-1.952-4.746c1.137-0.272,5.159-1.298,6.773-2.537 c1.608-1.233,3.313-3.252,3.298-5.396c-0.015-2.101-1.707-3.918-3.883-3.682c-3.021,0.328-5.642,5.14-6.191,7.797 c-0.034,0.166-0.213,2.117-0.291,3.19c-0.432-0.945-0.858-1.89-1.326-2.832c-1.35-2.719-2.801-5.429-4.237-8.139 c-0.44-0.83-0.869-1.662-1.301-2.493c0.406-0.093,5.212-1.208,7.021-2.596c1.608-1.233,3.313-3.252,3.298-5.397 c-0.015-2.1-1.707-3.918-3.883-3.681c-3.021,0.328-5.642,5.14-6.19,7.797c-0.041,0.2-0.295,3.007-0.324,3.724 c-0.951-1.831-1.882-3.665-2.727-5.51c-1.169-2.544-2.175-5.105-2.966-7.658c0.189-0.043,5.211-1.185,7.064-2.606 c1.608-1.234,3.313-3.252,3.297-5.397c-0.014-2.1-1.707-3.917-3.883-3.681c-3.021,0.328-5.642,5.14-6.19,7.797 c-0.043,0.209-0.314,3.229-0.324,3.78c-0.047-0.152-0.112-0.304-0.157-0.456c-0.81-2.737-1.251-5.489-1.537-8.087 c-0.169-1.509-0.247-2.96-0.291-4.374c0.957-0.117,5.325-0.698,7.134-1.793c1.734-1.05,3.65-2.868,3.871-5.002 c0.216-2.089-1.267-4.082-3.456-4.086c-3.038-0.006-6.173,4.49-7.009,7.07c-0.046,0.141-0.35,1.618-0.557,2.698 c-0.01-0.638-0.032-1.297-0.03-1.909c0.004-2.298,0.149-4.402,0.293-6.264c0.09-1.058,0.193-2.014,0.299-2.906 c0.879-0.605,4.393-3.085,5.474-4.858c1.055-1.73,1.917-4.227,1.13-6.223c-0.771-1.953-3.005-3.038-4.949-2.034 c-2.699,1.395-3.409,6.829-2.963,9.505c0.039,0.231,1.058,3.779,1.105,3.748c0,0,0.043-0.03,0.053-0.037 c-0.119,0.857-0.236,1.777-0.343,2.785c-0.185,1.863-0.377,3.969-0.431,6.275c-0.06,2.305-0.061,4.811,0.177,7.45 c0.235,2.645,0.617,5.417,1.38,8.222c0.009,0.032,0.022,0.064,0.031,0.095c-0.478-0.751-1.885-2.806-2.011-2.951 c-1.775-2.052-6.411-4.973-9.208-3.786c-2.015,0.856-2.605,3.268-1.593,5.109C664.675,368.303,667.148,369.232,669.153,369.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M721.255,355.25c0.047,0.029,0.97-3.545,1.003-3.777c0.374-2.687-0.483-8.099-3.219-9.421 c-1.971-0.952-4.174,0.193-4.892,2.167c-0.734,2.015,0.196,4.488,1.297,6.189C716.737,352.406,721.252,355.247,721.255,355.25z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 38.072,
    y1: 423.784,
    x2: 740.843,
    y2: 423.784
  })), /*#__PURE__*/React.createElement("g", {
    id: "Scale"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M569.407,127.953 c-0.425,0.223-12.01,13.769-14.058,38.682C554.724,166.932,573.923,157.915,569.407,127.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M545.838,112.07 c0.149,0.742-1.915,20.241,8.587,40.887C554.506,153.831,563.712,131.08,545.838,112.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M535.163,136.776 c0.367,0.368,2.825,18.437,18.957,30.964C554.65,168.184,554.987,143.466,535.163,136.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M574.397,153.915 c-0.458,0.162-14.254,11.299-20.561,35.69C553.185,189.822,573.609,184.004,574.397,153.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M535.019,157.412 c0.313,0.315,0.473,18.089,15.199,31.864C550.694,189.679,553.801,165.729,535.019,157.412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M572.705,183.189 c-0.484,0.087-16.146,8.179-26.961,30.986C545.074,214.295,566.202,212.318,572.705,183.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M533.395,179.035 c0.241,0.348-2.981,17.762,8.861,34.133C542.651,213.632,550.234,190.709,533.395,179.035z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M565.484,211.452 c-0.506,0.003-17.359,4.911-32.401,25.453C532.397,236.918,553.592,238.825,565.484,211.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M527.687,199.904 c0.174,0.373-6.303,16.936,2.158,35.354C530.163,235.776,542.013,214.557,527.687,199.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M553.015,237.908 c-0.524-0.089-17.927,1.573-36.914,19.156C515.405,256.962,536.069,262.72,553.015,237.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M518.084,219.421 c0.109,0.393-9.486,15.596-4.854,35.414C513.473,255.401,529.374,236.578,518.084,219.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M535.592,261.744 c-0.538-0.189-17.886-1.762-40.53,12.162C494.359,273.679,513.927,283.179,535.592,261.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M504.785,236.969 c0.047,0.405-12.52,13.724-12.122,34.2C492.835,271.778,512.561,256.06,504.785,236.969z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M513.513,282.132 c-0.549-0.297-17.272-5.017-43.282,4.535C469.526,286.308,487.472,299.364,513.513,282.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M487.995,251.92 c-0.012,0.411-15.399,11.303-19.591,31.597C468.506,284.161,491.823,272.276,487.995,251.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M202.253,127.953 c0.425,0.223,12.011,13.769,14.058,38.682C216.937,166.932,197.738,157.915,202.253,127.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M225.823,112.07 c-0.149,0.742,1.915,20.241-8.587,40.887C217.155,153.831,207.949,131.08,225.823,112.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M236.498,136.776 c-0.367,0.368-2.825,18.437-18.957,30.964C217.01,168.184,216.673,143.466,236.498,136.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M197.264,153.915 c0.458,0.162,14.254,11.299,20.561,35.69C218.476,189.822,198.052,184.004,197.264,153.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M236.642,157.412 c-0.313,0.315-0.473,18.089-15.199,31.864C220.967,189.679,217.86,165.729,236.642,157.412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M198.955,183.189 c0.484,0.087,16.146,8.179,26.961,30.986C226.587,214.295,205.459,212.318,198.955,183.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M238.266,179.035 c-0.241,0.348,2.981,17.762-8.861,34.133C229.01,213.632,221.426,190.709,238.266,179.035z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M206.177,211.452 c0.506,0.003,17.359,4.911,32.401,25.453C239.264,236.918,218.069,238.825,206.177,211.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M243.974,199.904 c-0.174,0.373,6.303,16.936-2.158,35.354C241.498,235.776,229.647,214.557,243.974,199.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M218.645,237.908 c0.524-0.089,17.927,1.573,36.914,19.156C256.256,256.962,235.592,262.72,218.645,237.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M253.577,219.421 c-0.109,0.393,9.485,15.596,4.854,35.414C258.188,255.401,242.286,236.578,253.577,219.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M236.069,261.744 c0.538-0.189,17.885-1.762,40.53,12.162C277.302,273.679,257.734,283.179,236.069,261.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M266.876,236.969 c-0.047,0.405,12.52,13.724,12.122,34.2C278.826,271.778,259.1,256.06,266.876,236.969z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M258.148,282.132 c0.549-0.297,17.272-5.017,43.282,4.535C302.135,286.308,284.189,299.364,258.148,282.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M283.666,251.92 c0.012,0.411,15.399,11.303,19.591,31.597C303.155,284.161,279.838,272.276,283.666,251.92z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M512.141,174.864 l-34.594-90.848h11.239c2.887,0,5.161-2.629,4.557-5.624c-0.44-2.178-2.457-3.685-4.678-3.685h-26.505 c-0.779,0-1.503,0.21-2.148,0.549L407.442,59.65c-0.973-2.227-3.19-3.787-5.776-3.787l-6.82-1.316v-2.394 c0-3.638-2.949-6.587-6.587-6.587h0c-3.638,0-6.587,2.949-6.587,6.587v2.25l-7.567,1.461c-2.871,0-5.267,1.931-6.029,4.556 l-49.98,14.838c-0.645-0.339-1.369-0.549-2.148-0.549h-26.505c-2.222,0-4.239,1.507-4.678,3.685 c-0.605,2.995,1.67,5.624,4.556,5.624h10.445v1.013l-34.153,89.689h-1.349c-0.209,0-0.395,0.129-0.468,0.325 c-0.073,0.195-0.017,0.415,0.14,0.552l8.354,7.281c0.091,0.079,0.208,0.123,0.329,0.123c0,0,55.933-0.044,56.024-0.123 c0,0,12.236-7.616,12.345-7.86c0.109-0.244-3.289,0.095-3.385-0.153l-34.594-90.848h12.94c1.742,0,3.243-0.969,4.041-2.386 l49.889-14.811c1.12,1.019,2.594,1.656,4.227,1.656l7.567-1.413v4.85h4.456v175.923h-5.964v7.669h-45.228v6.64h106.646v-6.64 h-45.228v-7.669h-5.965V71.912h4.456v-4.8l6.82,1.362c1.904,0,3.59-0.861,4.746-2.195l51.706,15.351 c0.798,1.417,2.299,2.386,4.041,2.386h12.146v1.013l-34.153,89.689h-1.349c-0.208,0-0.395,0.129-0.468,0.325 c-0.073,0.195-0.018,0.415,0.14,0.552l8.354,7.281c0.091,0.079,0.208,0.123,0.329,0.123c0,0,55.933-0.044,56.024-0.123 c0,0,12.236-7.616,12.345-7.86C515.635,174.773,512.237,175.113,512.141,174.864z M299.767,174.72h-32.015l32.015-84.074V174.72z  M302.263,174.72V87.674l33.147,87.046H302.263z M388.353,60.21c-1.29,0-2.336-1.046-2.336-2.336c0-1.29,1.046-2.336,2.336-2.336 c1.29,0,2.336,1.046,2.336,2.336C390.689,59.164,389.643,60.21,388.353,60.21z M474.305,174.72H442.29l32.015-84.074V174.72z  M476.801,174.72V87.674l33.147,87.046H476.801z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M317.594,291.181c0,0-2.118,24.006-2.12,25.44c-0.001,1.434-27.797,67.734-29.955,73.791c-2.158,6.057-6.472,17.931-5.043,23.137 c1.429,5.205,9.311,10.167,13.851,11.67c4.54,1.503,13.623,1.4,15.296,1.098c1.673-0.302,10.517-0.156,10.517-0.156l8.626-20.642 l-7.645-3.776l11.508-33.18l-4.74-39.973L317.594,291.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M321.122,401.743 c0,0-17.918-8.17-27.24-7.82"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M336.382,395.596 l-2.287,28.183h123.365c-4.368-25.554-4.368-45.598-4.368-45.598s6.193-49.805,6.199-55.711s4.748-22.915,3.57-25.824 c-1.178-2.909-27.154-10.79-38.37-14.798c-11.216-4.008-27.157-7.542-27.157-7.542l-29.235,3.166c0,0-34.258,6.308-41.641,7.471 c-7.383,1.163-8.271,2.969-8.865,6.239c-0.594,3.271,10.295,37.409,10.295,37.409L336.382,395.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M364.282,295.275 c0,0,2.283,15.549,5.258,28.312c2.975,12.764,11.232,31.766,11.232,31.766s20.036-32.482,23.04-47.54 c3.004-15.058,3.929-19.691,3.929-19.691l-43.222-0.444L364.282,295.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M368.909,267.51 c0,0-4.149,10.272-6.222,14.259c-2.073,3.987-14.046,20.991-13.358,22.344c0.688,1.354,6.668-0.481,8.278-1.231 c1.61-0.75,8.97-3.556,8.97-3.556s-1.613,3.509-0.924,4.633c0.689,1.124,11.714,11.286,11.714,11.286l8.736,0.131 c0,0,1.381-1.661,2.992-3.101c1.611-1.44,12.424-8.284,15.185-10.227c2.761-1.943,2.996-7.01,2.996-7.01 s14.246,7.741,14.939,4.956c0.693-2.785-2.983-6.096-6.651-15.614c-3.669-9.519-5.042-15.675-8.026-20.161 c-2.984-4.486-4.134-4.673-4.134-4.673L368.909,267.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M371.892,273.376 c0,0,0.893,25.257,1.119,29.617c0.225,4.36,9.171,24.027,10.783,21.437c1.612-2.59,11.978-22.063,15.205-29.311 c3.226-7.249,4.391-21.777,4.854-24.784c0.463-3.006,0.937-16.589,0.937-16.589s-11.974,18.154-16.805,20.865 C383.154,277.321,371.892,273.376,371.892,273.376z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 386.923,280.123 372.485,289.008 371.892,273.376  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M328.767,405.519c0,0,27.245,3.517,29.157,3.445s10.512,4.863,13.617,7.137c3.105,2.273,9.177,7.548,9.177,7.548l-31.654,0.706 c0,0-3.585-0.821-5.497-0.749s-4.543,1.605-10.04,1.573c-5.497-0.032-11.709-2.667-11.709-2.667L328.767,405.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M338.928,418.966 c0,0,5.85-1.308,7.754-0.427c1.903,0.881,9.38,5.224,9.38,5.224"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M343.693,414.706 c0,0,8.977-0.065,10.473,0.423c1.496,0.488,10.737,8.574,10.737,8.574"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M352.266,411.663 c0,0,7.209,0.001,8.296,1.048c1.087,1.047,11.688,9.491,12.503,10.548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M422.878,413.9 l-4.653-10.447l11.09-1.254C429.314,402.199,430.265,410.854,422.878,413.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M442.466,317.787c0,0-15.079,19.17-15.379,23.906c-0.3,4.736,6.45,43.755,6.45,43.755l-13.29,3.157c0,0,3.533,9.316,3.528,14.632 c-0.005,5.315-0.897,10.664-0.897,10.664s26.274,5.213,33.361,4.356c7.087-0.857,9.157-3.592,13.593-9.96 c4.436-6.368-0.868-17.094-3.224-22.911c-2.356-5.817-1.467-8.803-1.467-8.803l-6.728-60.576"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M433.537,385.447c0,0,15.948-3.552,25.693-3.919"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M383.743,366.461l-4.368-24.315c0,0-25.525,1.169-36.823,1.803c-11.298,0.634-44.98-0.401-44.98-0.401 s19.404,51.157,21.073,55.279c1.669,4.122,3.13,7.623,3.13,7.623s19.662,3.445,39.329,2.915 c19.667-0.53,28.458-5.254,28.458-5.254L383.743,366.461z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M420.247,388.604l-9.325-3.707c0,0-15.888-12.165-17.35-13.575c-1.463-1.41-9.828-4.861-9.828-4.861l1.873,9.763 c0,0-28.466,12.786-30.351,14.322c-1.884,1.535,2.089,2.851,2.089,2.851s-3.768,2.443-1.887,3.628 c1.882,1.185,8.368,0.941,8.368,0.941s3.973,2.152,8.157,2.622c4.184,0.47,13.807,0.945,13.807,0.945s-1.048,1.713-4.187,2.668 s-12.557,4.029-11.303,5.655c1.254,1.627,10.251,0.033,10.251,0.033s17.159-3.783,17.787-3.807 c0.628-0.024,6.066,1.236,8.786,1.134c2.72-0.102,8.997-1.175,8.997-1.175l7.532-0.074 C423.662,405.968,423.503,393.376,420.247,388.604z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 385.616,
    y1: 376.224,
    x2: 390.849,
    y2: 373.726
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 357.354,
    y1: 393.397,
    x2: 386.026,
    y2: 383.95
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 363.835,
    y1: 397.966,
    x2: 390.619,
    y2: 393.193
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 385.799,
    y1: 401.533,
    x2: 393.331,
    y2: 401.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M389.667,189.651c0,0,1.708-9.286,4.621-9.881c2.913-0.595,21.236,0.757,24.628,6.211c3.392,5.454,4.703,24.235,3.003,26.24 c-1.701,2.005-12.137,3.854-13.351,3.899c-1.213,0.046-5.325-13.39-11.871-18.482 C390.15,192.545,389.667,189.651,389.667,189.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M357.632,192.554c0,0-8.012,3.941-9.473,8.607c-1.461,4.666-1.709,9.771-1.709,9.771s-10.196,3.538-8.99,11.258 c1.205,7.72,9.694,12.497,10.421,12.956c0.728,0.458,7.995,12.319,7.995,12.319l0.738-9.978c0,0-0.484-1.681,10.68-2.586 c11.164-0.905,18.928,0.259,22.083-0.588c3.156-0.847,4.369-1.135,4.369-1.135s0.727,0.943,4.122,2.757 c3.396,1.814,8.002,5.766,9.702,4.489c1.7-1.277,3.896-12.28,3.896-12.28s1.476-18.742,1.479-22.139 c0.004-3.398-7.512-10.153-9.452-11.778c-1.94-1.626-17.949-8.304-21.588-9.381c-3.639-1.077-14.318,0.296-18.446,2.877 C359.333,190.306,357.632,192.554,357.632,192.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M352.008,233.049c0,0,6.77,23.285,7.493,28.112c0.625,4.17,5.661,8.343,8.465,11.102c2.901,2.855,12.977,13.801,17.236,9.772 c2.672-2.527,12.798-12.359,15.714-16.351s3.484-9.851,4.458-13.528s0.974-3.677,0.974-3.677s4.857-3.095,5.589-7.248 c0.732-4.153,3.169-13.466-0.472-13.087c-3.64,0.38-3.889,6.213-4.134,7.921c-0.244,1.708-2.184,0.082-3.396-1.086 c-1.212-1.168-4.367-1.292-5.821-2.936c-1.454-1.644,1.956-14.391,0.257-13.357c-1.7,1.035-2.922,10.06-13.843,10.713 c-10.921,0.653-18.442-1.005-18.442-1.005S361.227,236.343,352.008,233.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M375.948,242.277 c0,0-21.179-0.802-21.779-0.18c-0.6,0.622,1.39,8.14,3.186,10.471c1.796,2.33,10.988,1.985,13.786,0.681 C373.94,251.943,375.948,242.277,375.948,242.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M379.745,242.134 c0,0,3.786,10.048,5.983,11.165c2.197,1.116,7.791,1.505,10.789,0.993c2.998-0.512,5.197-2.194,5.598-3.008 c0.4-0.814,1.409-10.244,1.409-10.244L379.745,242.134z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 379.745,
    y1: 242.134,
    x2: 375.948,
    y2: 242.277
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 403.523,
    y1: 241.04,
    x2: 407.328,
    y2: 233.104
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M362.754,248.168 c0,0,4.392,3.632,8.193-0.308"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M386.732,248.066 c0,0,5.592,2.387,8.393-0.515"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M371.952,241.628 c0,0-6.991-2.734-12.387-1.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M383.143,240.607 c0,0,8.793-1.729,13.788-0.718"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M374.932,258.3 c0,0-0.204,3.804,0.195,4.389c0.399,0.585,1.996,2.323,3.594,2.063c1.599-0.26,4.798-2.378,4.798-2.378"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M373.125,267.16 c0,0,5.591,3.786,11.789-0.643"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M555.62,196.359c0,0,11.503-22.23,15.977-22.079c4.474,0.152,4.548,7.881,4.548,7.881s8.735-6.647,9.879-4.033 c1.143,2.614,1.143,2.614,1.143,2.614s20.761,5.294,28.828,15.086c8.067,9.792,11.961,20.449,8.341,28.165 c-3.621,7.716-10.424,33.353-10.424,33.353l2.776,10.62l-31.082,18.432l-7.275-13.348c0,0-15.949,4.723-18.01,2.75 c-2.061-1.973-10.477-27.902-10.477-27.902l-9.739-6.713c0,0,8.473-18.75,9.203-23.764 C550.037,212.407,553.055,202.655,555.62,196.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M553.854,253.904 c0,0,2.206,1.641,5.176-3.827"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M555.62,196.359c0,0,11.503-22.23,15.977-22.079c4.474,0.152,4.548,7.881,4.548,7.881s8.735-6.647,9.879-4.033 c1.143,2.614,1.143,2.614,1.143,2.614s20.761,5.294,28.828,15.086c8.067,9.792,11.961,20.449,8.341,28.165 c-2.799,5.965-7.497,22.63-9.487,29.892c-2.247,0.935-4.601,1.654-6.932,1.914c-10.004,1.117-19.667-7.833-19.667-7.833 s5.844-3.945,3.672-12.529c-2.173-8.584-8.105-8.673-8.105-8.673s-3.143,6.836-7.918,5.667c-4.775-1.17,3.08-8.294,3.433-12.089 c0.352-3.795-4.448-7.541-5.83-9.716c-1.382-2.174,5.945-3.606,8.258-5.767c2.313-2.161-14.289-4.627-17.946-5.759 c-3.657-1.132,3.192-1.684,6.322-4.825C573.265,191.133,555.62,196.359,555.62,196.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M553.843,224.934c-0.11,2.049,0.512,3.749,1.391,3.796c0.878,0.047,1.68-1.576,1.79-3.625 c0.11-2.049-0.512-3.749-1.391-3.796C554.754,221.261,553.953,222.884,553.843,224.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M559.952,217.222 c0,0-4.171-9.1-9.073-3.219"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 588.25,247.967 581.3,248.179 581.11,253.772  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M574.447,291.127c0,0-5.713,5.356-6.428,8.57c-0.714,3.214-1.071,6.071-1.071,6.071s-10.356,14.283-11.427,22.139 c-1.071,7.856,2.142,24.996,2.142,24.996l20.711-61.419L574.447,291.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M617.4,256.048 c0,0-42.742,30.472-42.968,31.376c-0.226,0.905-0.452,9.724-0.452,9.724l49.298-32.564L617.4,256.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M573.98,297.148 c0,0-11.759,20.578-12.438,23.744s-7.689,47.941-7.689,47.941l-8.829,54.951h111.043c0,0-2.419-22.454-3.776-40.771 c-1.357-18.317-1.999-45.305-8.661-69.291c-3.747-13.49-20.353-49.139-20.353-49.139L573.98,297.148z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M520.371,363.849c0,0-5.754-10.276-6.987-11.714c-1.233-1.439-6.988-3.494-8.632-4.11c-1.644-0.616-15.208-5.138-16.03-5.138 c-0.822,0-1.85,1.85-1.644,3.905c0.205,2.055,3.699,4.521,4.521,4.727c0.822,0.206-10.481,0.206-14.386,0.617 c-3.905,0.411-11.303,1.85-11.92,3.494c-0.617,1.644,0,3.288,2.261,3.494c2.261,0.206,6.576-0.411,6.576-0.411l10.687,1.028 c0,0-13.769,2.055-15.825,2.466c-2.055,0.411-3.288,3.083-2.261,4.521c1.028,1.439,6.987,0.616,6.987,0.616l10.07-0.616 c0,0-13.153,4.11-13.769,4.932c-0.617,0.822-0.206,3.288,1.644,3.699c1.85,0.411,10.481-0.616,10.481-0.616l4.316,0.616 c0,0-6.165,0.822-6.165,1.644c0,0.822,0,2.055,1.439,2.055s10.892-0.206,10.892-0.206s4.316,2.466,8.015,2.261 c3.699-0.205,18.907-2.055,18.907-2.055L520.371,363.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M491.599,351.519 l6.499,3.187c0,0,0,6.219,5.741,10.286"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M484.703,358.055 c0,0,1.435,12.678,2.392,15.787"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 557.779,366.284 529.555,364.807 529.555,380.423 554.195,383.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 529.555,364.807 520.371,363.54 519.475,379.157 529.555,380.423  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M610.466,299.585c0,0-8.488-6.111-13.58-5.093c-5.092,1.018-20.031,6.111-23.426,12.901c-3.395,6.79-24.105,68.58-24.105,68.58 l-78.713-5.838l-2.912,28.448c0,0,84.68,17.791,91.47,18.81c6.79,1.018,14.259,1.018,17.654-2.377 c3.395-3.395,39.043-80.123,39.043-80.123"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 470.643,370.135 457.875,368.344 456.778,392.63 467.955,394.327  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M457.875,368.344c0,0-6.496-8.288-7.84-11.648c-1.344-3.36-8.288-3.808-11.424-4.704c-3.136-0.896-7.616-2.688-8.064-1.12 c-0.448,1.568-0.672,4.928,1.12,6.272s6.048,2.24,7.168,3.136s2.24,1.792,2.24,1.792l-20.384,2.016c0,0-9.408-1.344-13.664,0 c-4.256,1.344-7.616,1.344-7.84,3.136c-0.224,1.792,0.224,4.256,1.344,4.48s4.704-0.224,5.376-0.224c0,0-2.464,2.464-2.24,3.36 s1.792,3.36,2.688,3.36s6.496,0.448,7.392,0.672s4.928,4.256,5.824,4.704s7.168,2.688,7.168,2.688s2.24,1.792,6.72,2.912 c4.48,1.12,23.319,3.455,23.319,3.455L457.875,368.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M426.927,385.657 c0,0,2.292,0.441,4.761,0.793"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 405.907,371.479 416.883,371.031 427.635,372.151  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 413.747,378.871 419.795,379.319 429.203,379.767  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M677.622,423.993 l6.25-62.48c0.882-8.812-5.866-16.536-14.717-16.847l0,0c-7.836-0.275-14.617,5.408-15.716,13.171l-9.371,66.156H677.622z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M188.516,252.378c0,0-40.979,21.972-42.741,23.79c-1.762,1.818-11.922,132.679-11.922,132.679l124.277-16.796 c0,0,12.868-57.462,15.234-80.668c2.366-23.207,1.687-40.315,1.015-42.271c-0.673-1.957-19.269-11.548-23.582-13.589 c-4.312-2.04-10.842-4.478-10.842-4.478L188.516,252.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M245.342,340.59 c-10.114,10.414-32.89,32.523-53.263,42.765"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M250.678,334.946 c0,0-1.284,1.419-3.557,3.797"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M185.389,378.081 c-2.973,1.381-5.623,2.386-7.579,2.726"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M212.971,361.953 c0,0-12.147,8.134-22.812,13.752"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M192.879,393.262c0,0-28.474-14.112-31.992-15.444c-3.518-1.331-17.71,14.71-17.71,14.71l57.208,13.31L192.879,393.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M149.394,394.235 c0,0,8.982-12.328,13.419-14.019"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M157.998,395.585 c0,0,7.654-11.026,10.356-13.136"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M164.914,397.011 c0,0,5.58-9.939,8.788-11.823"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M169.613,398.04 c0,0,3.378-2.637,4.631-2.196s6.961,4.405,7.996,5.103"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M274.379,269.112c0,0-1.937,7.539-6.848,21.919s-8.607,21.253-8.607,21.253L247.634,381.1l-54.755,12.162l7.506,12.577 c0,0,31.501,2.798,47.342-1.147c15.841-3.945,22.665-5.992,23.463-7.767c0.798-1.775,7.955-40.598,7.624-66.663 C278.483,304.197,277.829,267.217,274.379,269.112z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 258.925,
    y1: 312.284,
    x2: 275.442,
    y2: 287.693
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 262.952,
    y1: 311.357,
    x2: 274.13,
    y2: 296.694
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M250.697,380.216 c0,0,11.547-0.77,17.011,5.689"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 198.81,
    y1: 392.001,
    x2: 207.399,
    y2: 405.77
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M250.17,377.26 c0,0,5.645-4.229,15.332-1.687"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 227.913,405.091 242.59,406.663 239.84,428.397 224.511,427.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M156.123,270.484c0,0-23.248,9.993-24.46,15.015c-1.211,5.022-14.654,59.033-20.159,87.349 c-5.506,28.316-7.482,48.028-5.675,49.188c1.807,1.16,31.328,6.035,66.808,7.412c35.48,1.377,50.303,1.948,51.848,0.388 c1.545-1.56,4.271-23.541,3.428-24.745c-0.842-1.204-80.346-14.748-80.346-14.748s20.475-68.983,20.454-71.714 c-0.021-2.731-10.508-21.134-14.624-26.164"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M147.567,390.343 c0,0-13.578-1.893-23.26,8.298"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M124.307,393.036 c0,0-6.115,6.115-7.643,11.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M242.59,406.663c0,0,30.721-10.331,32.792-8.934c2.071,1.397,13.943,11.541,14.085,13.024c0.143,1.484-0.223,5.226-1.381,5.775 c-1.158,0.549-3.28,1.142-3.28,1.142s-3.291,11.078-4.642,12.132c-1.351,1.055-5.378,1.982-7.282,2.316 c-1.905,0.335-33.043-3.722-33.043-3.722L242.59,406.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M284.807,417.671 c0,0-2.598-4.353-3.875-5.041c-1.277-0.687-8.553-3.339-8.553-3.339"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M271.237,417.539 c0,0,8.627,1.597,11.348,4.703"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M270.553,425.518 c0,0,7.197,2.582,10.983,1.666"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 205.366,291.606 213.473,305.397 200.825,400.355 209.822,415.845 226.788,398.436 217.113,305.481 226.558,287.915  216.083,279.695  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M193.754,246.428 l-7.357,4.058c0,0-0.065,14.409,3.824,27.149c3.89,12.74,7.374,21.276,7.374,21.276l19.103-10.302l18.811,11.817 c0,0,2.571-13.529,1.381-25.894c-1.19-12.365-6.381-26.04-6.381-26.04S203.932,241.497,193.754,246.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M200.914,265.478 c0,0,3.413,7.794,5.723,11.664c2.309,3.87,10.062,11.468,10.062,11.468s7.824-11.779,9.321-13.834 c1.497-2.055,1.497-2.055,1.497-2.055s-10.077,0.952-12.318,0.309C212.958,272.385,200.914,265.478,200.914,265.478z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M246.866,219.112c0,0-3.931,20.499-3.858,23.231c0.073,2.732,1.826,11.055,0.609,14.236 c-1.217,3.181-14.754,16.885-19.005,20.204c-4.252,3.319-10.376,3.009-13.691,0.228c-3.315-2.781-14.564-14.778-16.418-18.211 c-1.854-3.433-3.872-12.526-3.872-12.526s-5.401-2.687-8.58-8.014c-3.179-5.327-4.863-8.964-0.536-11.504l-1.983-22.577 c0,0,7.461-7.567,25.113-6.216C222.296,199.315,246.866,219.112,246.866,219.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M188.998,231.302l4.198,9.971l2.503,0.278l-1.299-7.562c0,0,9.962-5.335,10.493-5.75c0.531-0.415-2.203-12.992-2.315-14.159 c-0.112-1.167,0.632-5.304,14.754-1.058c14.122,4.246,14.609,9.305,21.585,10.553c6.977,1.248,7.663-1.519,7.663-1.519 s7.602,1.806,11.818-3.856c4.216-5.662-8.234-12.329-8.234-12.329s2.023-10.643-2.997-15.301 c-5.019-4.658-9.519,0.04-9.463,0.623c0.056,0.584-18.132-12.272-27.138-12.842c-9.006-0.57-29.388,13.248-32.905,20.246 c-3.516,6.998,3.854,28.158,3.854,28.158S186.104,224.985,188.998,231.302z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 231.667,243.247 232.009,258.668 224.293,257.649  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M216.457,261.325 c0,0,6.384,4.987,13.157,2.141"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M221.373,241.172 c0,0-2.243,4.4-9.767,1.419"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M234.023,240.014 c0,0,3.259,2.197,6.808-0.503"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M203.457,239.051 c0,0,9.067-2.755,25.811-2.926c0,0-1.484,4.366-3.025,8.148c-1.54,3.782-2.018,6.735-8.182,7.99 c-6.164,1.256-11.338-1.051-12.321-3.351C204.756,246.613,203.457,239.051,203.457,239.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M229.268,236.125 c0,0,15.857-3.452,20.541-4.25c0,0,0.07,4.686-1.128,8.062c-1.199,3.376-3.743,6.617-6.134,7.507 c-2.39,0.89-7.777,2.306-9.158-0.172C232.706,246.048,229.268,236.125,229.268,236.125z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 249.809,
    y1: 231.875,
    x2: 245.016,
    y2: 227.598
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 203.457,
    y1: 239.051,
    x2: 188.998,
    y2: 231.302
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M209.225,235.664 c0,0,6.033-2.617,13.939-1.607"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M233.575,233.391 c0,0,2.318-3.622,9.276-2.569"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "504.104,447.88  479.889,435.663 587.385,435.663 618.574,447.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "515.793,447.435  495.06,436.975 587.101,436.975 613.806,447.435  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "504.104,447.88 618.574,447.88  634.185,374.197 519.715,374.197  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M564.23,408.79 c-2.888,2.868-3.109,7.327-0.495,9.96c2.615,2.633,7.075,2.443,9.963-0.425c2.888-2.867,3.109-7.327,0.495-9.96 S567.118,405.922,564.23,408.79z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Papers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 347.151,427.599 297.74,449.798 387.252,454.811 428.07,429.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 354.265,428.103 311.364,456.243 402.702,464.085 417.002,428.565  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Books"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M206.704,411.708 c0-3.854,0.987-7.389,2.628-10.145h-84.752c-5.443,0-9.855,4.412-9.855,9.855c0,5.443,4.412,9.855,9.855,9.855h84.439 C207.572,418.606,206.704,415.302,206.704,411.708z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M209.019,423.01h-84.439 c-6.392,0-11.592-5.2-11.592-11.592c0-6.392,5.2-11.592,11.592-11.592h84.752c0.96,0,1.737,0.778,1.737,1.737 c0,0.959-0.778,1.737-1.737,1.737h-84.752c-4.476,0-8.118,3.642-8.118,8.118c0,4.476,3.642,8.118,8.118,8.118h84.439 c0.96,0,1.737,0.778,1.737,1.737C210.756,422.232,209.978,423.01,209.019,423.01z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M197.545,401.563 c-1.642,2.756-2.628,6.291-2.628,10.145c0,3.594,0.868,6.899,2.315,9.565h11.787c-1.447-2.666-2.315-5.971-2.315-9.565 c0-3.854,0.987-7.389,2.628-10.145H197.545z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M209.095,434.702 c0-3.854,0.986-7.388,2.628-10.145h-84.752c-5.443,0-9.855,4.412-9.855,9.855c0,5.443,4.412,9.855,9.855,9.855h84.439 C209.963,441.601,209.095,438.296,209.095,434.702z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M211.41,446.005h-84.439 c-6.392,0-11.592-5.2-11.592-11.592c0-6.392,5.2-11.592,11.592-11.592h84.752c0.959,0,1.737,0.778,1.737,1.737 c0,0.959-0.778,1.737-1.737,1.737h-84.752c-4.476,0-8.118,3.642-8.118,8.118c0,4.476,3.642,8.118,8.118,8.118h84.439 c0.96,0,1.737,0.778,1.737,1.737C213.147,445.227,212.369,446.005,211.41,446.005z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M199.936,424.558 c-1.642,2.756-2.628,6.291-2.628,10.145c0,3.594,0.868,6.899,2.315,9.565h11.787c-1.447-2.666-2.315-5.971-2.315-9.565 c0-3.854,0.986-7.388,2.628-10.145H199.936z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelines);
export default __webpack_public_path__ + "static/media/Guidelines.785c01496d41bca7c8be6d29732aacd5.svg";
export { ForwardRef as ReactComponent };